// extracted by mini-css-extract-plugin
module.exports = {"watermark":"styles-module--watermark--1v6da","shop":"styles-module--shop--2B2bV","shopLocked":"styles-module--shopLocked--2r5RB"};